<template>
  <div>
    <!-- 详情弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      :title="editTitle"
      :visible.sync="defailDialogVisible"
      :before-close="defailHandleClose"
      width="40.2%"
      center
    >
      <el-divider></el-divider>
      <el-form class="editForm" ref="form" label-width="124px" :rules="rules" :model="form">
        <div class="flexDis itemInp">
          <el-form-item label="二级分销商简称:" prop="Name">
            <el-input v-model="form.Name" placeholder="请输入简称"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="二级分销商全称:" prop="FullName">
          <el-input v-model="form.FullName" placeholder="请输入分销商全称"></el-input>
        </el-form-item>
        <el-form-item label="地址:" prop="ZoneID">
          <div class="flexDis itemSele">
           <el-select
                v-model="form.ProID"
                placeholder="请选择省"
                @change="provinceChange($event)"
              >
                <el-option
                  v-for="item in cityProvince"
                  :key="item.provinceCode"
                  :label="item.provinceName"
                  :value="item.provinceCode"
                ></el-option>
              </el-select>
            <el-select
                v-model="form.CityID"
                placeholder="请选择市/区"
                @change="cityChange($event)"
              >
                <el-option
                  v-for="item in cityDistrict"
                  :key="item.cityCode"
                  :label="item.cityName"
                  :value="item.cityCode"
                ></el-option>
              </el-select>
             <el-select v-model="form.ZoneID" placeholder="请选择县/乡">
              <el-option
                v-for="item in cityCounty"
                :key="item.countyCode"
                :label="item.countyName"
                :value="item.countyCode"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="详细地址:" prop="Address">
          <el-input v-model="form.Address" placeholder="请输入详细地址至门牌号"></el-input>
        </el-form-item>
        <div class="flexDis itemMoble">
          <el-form-item label="联系人:" prop="LinkMan">
            <el-input v-model="form.LinkMan" placeholder="请输入景区联系人姓名"></el-input>
          </el-form-item>
          <div>
            <el-form-item label="联系方式:" prop="Phone">
              <el-input v-model="form.Phone" placeholder="请输入联系人电话"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="flexDis itemMoble">
          <el-form-item label="Email:" prop="E_Mail">
            <el-input v-model="form.E_Mail" placeholder="请输入景区联系人邮箱"></el-input>
          </el-form-item>
          <div>
            <el-form-item label="是否发送短信:" prop="sms_flag">
              <el-radio-group v-model="form.sms_flag">
                <el-radio :label="1">发送</el-radio>
                <el-radio :label="2">不发送</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </div>
        <div class="endItem"  >
          <el-form-item label="可透支金额:">
            <el-input v-model="form.OverDraftMoney" placeholder="请输入数量"></el-input>
            <span class="dW">元</span>
          </el-form-item>
        </div>
        <el-form-item class="itemBtnS" v-if="!flow">
          <el-button @click="empty">清空</el-button>
          <el-button class="btnL" @click="succBtns('form')">确认保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 编辑详情弹框结束 -->
  </div>
</template>

<script>
import {getDistributorTwoInfo,addDistributorTwo} from "@/request/distributor.js"
import cityOptions from "@/assets/city.json";
// import { validate } from "json-schema";
export default {
  data() {
    var checkEmail = (rule,value,cb) => {
        //验证邮箱的正则表达式
        const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
        if(regEmail.test(value)){
          //合法的邮箱
          return cb();
        }
        //邮箱不合法
        cb(new Error('请输入合法的邮箱！'));
      }
      //验证手机号的规则
    var checkMobile = (rule,value,cb) =>{
      const regMobile = /^(0|86|17951)?(13[0-9]|15[0123456789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      if(regMobile.test(value)){
        //合法的手机号
        return cb();
      }
      //手机号不合法
      cb(new Error('请输入合法的手机号！'));
    }
    return {
      defailDialogVisible: false, // 详情弹框
      form: {
        token:window.sessionStorage.getItem('Token'),
        E_Mail:"",
        Name:'',
        Phone:"",
        FullName:"",
        ProID:'',
        CityID:"",
        ZoneID:"",
        Address:"",
        LinkMan:"",
        sms_flag:""
      },
      value: "",
      radio: 1,
      editTitle: "", // 弹框标题
      btnType: "", // 详情和确认按钮区别
      cityProvince:'',
      cityDistrict:[],
      cityCounty:[],
      flow:false,
      rules:{
        E_Mail:[{ required: true, message: '请输入邮箱', trigger: 'blur' },
        {validator: checkEmail, trigger: 'blur'}],
        Name:[{ required: true, message: '请输入分销商简称', trigger: 'blur' }],
        Phone:[{ required: true, message: '请输入分销商手机号', trigger: 'blur' },
        {validator: checkMobile, trigger: 'blur'}],
        FullName:[{ required: true, message: '请输入分销商全称', trigger: 'blur' }],
        ZoneID:[{ required: true, message: '请选择省市区', trigger: 'change' }],
        Address:[{ required: true, message: '请输入分销商地址', trigger: 'blur' }],
        LinkMan:[{ required: true, message: '请输入分销商联系人', trigger: 'blur' }],
        sms_flag:[{ required: true, message: '请选择是否发送短信', trigger: 'change' }]
      }
    };
  },
  created(){
    this.cityProvince = cityOptions;
  },
  methods: {
    // 清空
    empty(){
      this.form={
        token:window.sessionStorage.getItem('Token'),
        E_Mail:"",
        Name:'',
        Phone:"",
        FullName:"",
        ProID:'',
        CityID:"",
        ZoneID:"",
        Address:"",
        LinkMan:"",
        sms_flag:""
      }
    },
    // 获取详情信息
    getDetail(row){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        distrbutortwo_id:row.DistributorID
      }
      getDistributorTwoInfo(data).then(res=>{
          if(res.data.status=='ok'){
              this.flow = true
              this.form = res.data.result
              this.form.ProID = this.form.ProID + ''
              this.form.CityID = this.form.CityID+ ''
              this.form.ZoneID = this.form.ZoneID+ ''
               // 省赋值后获取市下拉框对应的值
              this.cityProvince.map((item, index) => {
                if (item.provinceCode == res.data.result.ProID) {
                  this.cityDistrict = item.cities;
                }
              });
              // 市赋值后获取县下拉框对应的值
              this.cityDistrict.map((item, index) => {
                if (item.cityCode == res.data.result.CityID) {
                  this.cityCounty = item.counties;
                }
              });
          }
      })
    },
     // 选中省
     provinceChange(e) {
      this.cityProvince.forEach((item, index) => {
        if (e == item.provinceCode) {
          this.form.CityID = ''
          this.form.ZoneID = ''
          this.cityDistrict = item.cities;
        }
      });
    },
    // 选中市
    cityChange(e) {
      this.cityDistrict.forEach((item, index) => {
        if (e == item.cityCode) {
          this.form.ZoneID = ''
          this.cityCounty = item.counties;
        }
      });
    },
    // 详情弹框
    addRetail(row) {
      if (row) {
        this.editTitle = "分销商详情";
        this.getDetail(row)
      } else {
        this.editTitle = "添加分销商";
      }
      this.btnType = 2;
      this.defailDialogVisible = true;
    },
    // 详情X
    defailHandleClose() {
      this.$emit('HandleClose')
      this.defailDialogVisible = false;
    },
    //添加二级分销商
    succBtns(form){
      this.$refs[form].validate((valid) =>{
        if(valid){
          addDistributorTwo(this.form).then(res=>{
              if(res.data.status=='ok'){
                this.$emit('HandleClose')
                this.defailDialogVisible = false;
                this.$message.success('添加分销商成功')
              }else{
                this.$message.error(res.data.msg)
              }
          })
        }
      })
    }
  }
};
</script>

<style lang='less' scoped>
/deep/.el-form-item {
  position: relative;
}
.absPosiA {
  position: absolute;
  top: 0px;
  left: -121px;
  color: #e74c3c;
}
.absPosiB {
  position: absolute;
  top: 0px;
  left: -121px;
  color: #e74c3c;
}
.absPosiE {
  position: absolute;
  top: 0px;
  left: -80px;
  color: #e74c3c;
}
.absPosiF {
  position: absolute;
  top: 0px;
  left: -65px;
  color: #e74c3c;
}

.absPosiH {
  position: absolute;
  top: 0px;
  left: -59px;
  color: #e74c3c;
}
.absPosiI {
  position: absolute;
  top: 0px;
  left: -106px;
  color: #e74c3c;
}
.absPosiD {
  position: absolute;
  top: 0px;
  left: -50px;
  color: #e74c3c;
}
.absPosiJ {
  position: absolute;
  top: 0px;
  left: -80px;
  color: #e74c3c;
}
.editForm {
  /deep/.el-form-item__label {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
  }

  .endItem {
    .el-input {
      // width: 240px;
      width: 95%;
      input{
        width: 100%;
      }
    }
    .dW {
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      margin-left: 10px;
    }
  }
  .itemBtnS {
    display: flex;
    justify-content: center;
    margin-top: 40px;
    margin-left: -100px;
    /deep/.el-button {
      width: 100px;
      height: 40px;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
    .btnL {
      width: 100px;
      height: 40px;
      background: #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
    }
  }
  .itemBtn {
    display: flex;
    justify-content: center;
    /deep/.el-form-item__content {
      margin-left: 0px;
    }
    /deep/.el-button {
      width: 100px;
      height: 40px;
      background: #ffffff;
      border: 1px solid #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #246deb;
    }
  }
  .el-form-item {
    margin-bottom: 20px;
  }
  .itemSele {
    /deep/.el-select {
      width: 190px;
      height: 40px;
      margin-right: 12px;
      margin-bottom: 10px;
      .el-input {
        width: 190px;
        height: 100%;
      }
    }
  }
  .itemMoble {
    /deep/.el-input {
      // width: 240px;
      height: 40px;
    }
  }

  .itemInp {
    // width: 500px;
    .el-form-item {
      // display: flex;
      margin-right: 45px;
      /deep/.el-input {
        // width:610px;
        height: 40px;
        /deep/.el-input__inner {
          width: 100%;
        }
      }
    }
  }
}
/deep/.el-dialog__header {
  height: 60px;
  line-height: 60px;
  padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
.flexDis{
  flex-wrap: wrap;
}
/deep/ .el-dialog{
  min-width: 400px;
}

</style>